export default __webpack_public_path__ + "static/media/Believer's Bracers of the Green Ones.4dcf5698.jpg";